import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface MapState {
    isVisible: boolean
    scrollToMap: boolean
}

const initialState: MapState = {
    isVisible: false,
    scrollToMap: false
}

const mapSlice = createSlice({
    name: 'map',
    initialState,
    reducers: {
        setMapVisibility: (state, action: PayloadAction<boolean>) => {
            state.isVisible = action.payload
        },
        setScrollToMap: (state, action: PayloadAction<boolean>) => {
            state.scrollToMap = action.payload
        }
    }
})

export const { setMapVisibility, setScrollToMap } = mapSlice.actions
export default mapSlice.reducer
